var exports = {
  "Qs": "GiftAcceptModal.module__content___a0luTm",
  "O8": "GiftAcceptModal.module__loadingContent___a0luTm",
  "Nr": "GiftAcceptModal.module__card___a0luTm",
  "$2": "GiftAcceptModal.module__cardGrid___a0luTm",
  "kJ": "GiftAcceptModal.module__iconCircle___a0luTm",
  "SP": "GiftAcceptModal.module__iconCircleActive___a0luTm",
  "PP": "GiftAcceptModal.module__iconCircleInactive___a0luTm",
  "_O": "GiftAcceptModal.module__iconCircleDisabled___a0luTm",
  "Kk": "GiftAcceptModal.module__icon___a0luTm",
  "m5": "GiftAcceptModal.module__iconError___a0luTm",
  "Ux": "GiftAcceptModal.module__cardContent___a0luTm",
  "DD": "GiftAcceptModal.module__title___a0luTm",
  "jn": "GiftAcceptModal.module__titlePrimary___a0luTm",
  "xP": "GiftAcceptModal.module__titleTertiary___a0luTm",
  "S3": "GiftAcceptModal.module__titleDanger___a0luTm",
  "VA": "GiftAcceptModal.module__subtitle___a0luTm",
  "BK": "GiftAcceptModal.module__helpText___a0luTm",
  "qr": "GiftAcceptModal.module__footer___a0luTm",
};

module.exports = exports;
